export const FETCH_XHQ_USERS = "FETCH_XHQ_USERS";
export const REMOVE_XHQ_USERS = "REMOVE_XHQ_USERS";
